import { render } from "./DownloadAppPage.vue?vue&type=template&id=701c1afa&scoped=true"
const script = {}

import "./DownloadAppPage.vue?vue&type=style&index=0&id=701c1afa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701c1afa"]])

export default __exports__